export const FETCHED_PINDATA = 'Pin code data fetched successfully';
export const ERROR_PINDATA = 'Error while fetching the pin data';
export const DATA_FETCH = 'Data fetch successfully';
export const UPLOAD_SUCEESS = 'File uploaded successfully';
export const GST_ERROR_MSG = "Image either doesn't contain gst number or image quality very poor";
export const VERIFY_SUCCESS = 'Data verified successfully';
export const VERIFY_ERROR = 'Error validating the data';
export const ERROR_FETCH = 'Failed to Fetch Data';
export const PAN_DETAILS_MISSING = 'Pan Details missing';
export const GST_DETAILS_MISSING = 'Gst Details missing';
export const FORM_ERRORS = 'Please fix the form errors';
export const ERROR_UBO = 'Error adding ubo in the list.';

export const GST = 'GST';
export const PAN = 'PAN';
export const BANK = 'BANK';
export const SUBMITTED_KEY = 'submitted';
export const KYC_FILES = 'kycfiles';
export const FILE_MSG = "Allowed max file size 5mb and file type pdf, images."
export const FILE_MSG_WITH_EXT = 'Allowed max file size 5mb and file types are ';
export const IMAGE_MSG = "Allowed max file size 5mb and file types are ";
export const MAX_ACTIVE_UBO_COUNT = 10;

export const UPDATE_FORMTYPES = {
    business: 'mleBusinessDetailUpdateForm',
    ubo: 'mleOwnershipDetailUpdateForm'
}

export const EDITABLE_FIELD_KYC = 'kycDocUrls';
export const FORMAT_DATE = 'MM/DD/YYYY';
export const FORMAT_DATE_TIME = 'DD/MM/YYYY, HH:mm';
export const DOCUMENT_CATEGORY = {
    POA: 'POA',
    POB: 'POB',
    POI: 'POI',
}